import Footer from 'src/components/UCA/Footer';
import Header from 'src/components/UCA/Header';
import List from 'src/components/UCA/List';
import ListItem from 'src/components/UCA/ListItem';
import SectionPage from 'src/components/UCA/SectionPage';
import { FOOTER_DETAILS, HEADER_DETAILS } from 'src/data/RefusalToSign/constant';

export default function RefusalToSign() {
  return (
    <SectionPage>
      <Header {...HEADER_DETAILS} />
      <ol className="list-none p-0 px-10 pt-4">
        <List prefix="1">
          <ListItem prefix="a">
            Each person who fails to file the signed statement required by Section 59-2-306, fails
            to file the signed statement with respect to name and place of residence, or fails to
            appear and testify when requested by the assessor, shall pay the penalty equal to 10% of
            the estimated tax due, by not less than $25 for each failure to file a signed and
            completed statement.
          </ListItem>
          <ListItem prefix="b">
            Each penalty under Subsection (1)(a) shall be collected in the manner provided by
            Sections 59-2-1302 and 59-2-1303, except as otherwise provided for in this section, or
            by a judicial proceeding brough in the name of the assessor.
          </ListItem>
          <ListItem prefix="c">
            All money recovered by any assessor under this section shall be paid into the county
            treasury
          </ListItem>
        </List>
        <List prefix="2">
          <ListItem prefix="a">
            Upon a showing of reasonable cause, a county may waive or reduce a penalty imposed under
            Subsection (1)(a)
          </ListItem>
          <ListItem prefix="b">
            <List level="1">
              <ListItem prefix="i">
                Except as provided in Subsection (2)(b)(ii), a penalty under Subsection (1)(a) may
                be imposed on or after May 16 of the year the statement described in Section
                59-2-306 is requested by the county assessor.
              </ListItem>
              <ListItem prefix="ii">
                A penalty under Subsection (1)(a) may not be imposed until 30 days after the
                postmark date of the mailing of a subsequent notice if the signed statement
                described ein Section 59-2-306 is requested:
                <List level="1">
                  <ListItem prefix="A">on or after March 16; or</ListItem>
                  <ListItem prefix="B">
                    by a county assessor of a county of the first class
                  </ListItem>
                </List>
              </ListItem>
            </List>
          </ListItem>
        </List>
        <List prefix="3">
          <ListItem prefix="a">
            If an owner neglects or refuses to file a signed statement requested by an assessor as
            required under Section 59-2-306:
            <List>
              <ListItem prefix="i">the assessor shall:</ListItem>
              <List level="1">
                <ListItem prefix="A">make a record of the failure to file; and</ListItem>
                <ListItem prefix="B">
                  make an estimate of the value of the property of the owner based on known facts
                  and circumstances; and
                </ListItem>
              </List>
              <List>
                <ListItem prefix="ii">
                  the assessor of a county of the first class:
                  <List>
                    <ListItem prefix="A">
                      shall make a subsequent request by mail for the signed statement, informing
                      the owner of the consequences of not filing a signed statement; and
                    </ListItem>
                    <ListItem prefix="B">
                      may impose a fee for the actual and necessary expenses of the mailing under
                      Subsection (3)(a)(ii)(A).
                      <List>
                        <ListItem prefix="b">
                          The value fixed by the assessor in accordance with Subsection (3)(a)(i)
                          may not be reduced by the county board of equalization or by the
                          commission.
                        </ListItem>
                      </List>
                    </ListItem>
                  </List>
                </ListItem>
              </List>
            </List>
          </ListItem>
        </List>
        <List prefix="4">
          <ListItem>
            If the signed statemnet discloses property in any other county, the assessor shall file
            the signed statement and send a copy to the assessor of each county in which the
            property is located.
          </ListItem>
        </List>
      </ol>
      <Footer {...FOOTER_DETAILS} />
    </SectionPage>
  );
}
